import { Plugin, Chart as ChartJS } from 'chart.js';

export const drawCurrentDateLine: Plugin<'line'> = {
  id: 'drawCurrentDateLine',
  afterDraw: (chart: ChartJS) => {
    const ctx = chart.ctx;
    const xAxis = chart.scales['x'];
    const yAxis = chart.scales['y'];

    if (!xAxis || !yAxis) return;

    const currentDate = new Date().getTime();
    const xPosition = xAxis.getPixelForValue(currentDate);

    ctx.save();
    ctx.beginPath();
    ctx.moveTo(xPosition, yAxis.top);
    ctx.lineTo(xPosition, yAxis.bottom);
    ctx.lineWidth = 1;
    ctx.strokeStyle = 'gray';
    ctx.stroke();
    ctx.restore();
  },
};
